import mainRoute from '../mainRoute';
import Cookies from 'universal-cookie';
import path from '../config.json';
import { PARENT_TOKEN, CHILD_TOKEN } from '../constants/const';

const cookies = new Cookies();

export const profileInfoRequest = async () => {
  return await fetch(`${mainRoute.route + path.userInfoRequest}`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Authorization: cookies.get(PARENT_TOKEN),
    },
    body: JSON.stringify({
      userInfo: {
        id: '',
        email: '',
        firstname: '',
        lastname: '',
        username: '',
        status: '',
        address: '',
        country: '',
        createdAt: '',
      },
      idChild: 'all',
      childInfo: {
        id: '',
        username: '',
        screenname: '',
        firstname: '',
        status: '',
        state: '',
        createdAt: '',
        childEmail: '',
      },
    }),
  });
};

export const parentInfo = async (childEmail) => {
  return await fetch(`${mainRoute.route}${path.parentInfo}`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Authorization: cookies.get(CHILD_TOKEN),
    },
    body: JSON.stringify({ childEmail }),
  });
};

export const editUser = async (responseData) => {
  return await fetch(`${mainRoute.route + path.edituser}`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Authorization: cookies.get(PARENT_TOKEN),
    },
    body: JSON.stringify({ ...responseData }),
  });
};

export const editChildUser = async (data) => {
  return await fetch(`${mainRoute.route + path.editplayer}`, {
    method: 'POST',
    headers: {
      Authorization: cookies.get(PARENT_TOKEN),
    },
    body: data,
  });
};

export const supportRequest = async (responseData) => {
  return await fetch(`${mainRoute.route + path.support}`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Authorization: cookies.get(PARENT_TOKEN),
    },
    body: JSON.stringify({ ...responseData }),
  });
};

export const contactRequest = async (responseData) => {
  return await fetch(`${mainRoute.route + path.contactus}`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Authorization: '',
    },
    body: JSON.stringify({ ...responseData }),
  });
};

export const signInRequest = async (email, password, requestPath, fieldKey) => {
  return await fetch(`${mainRoute.route + path[requestPath]}`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({
      [fieldKey]: email,
      password: password,
    }),
  });
};

export const childInfoRequest = async (userId = undefined) => {
  let endPoint = `${mainRoute.route + path.onlyPlayerInfoRequest}`;
  if (userId) {
    endPoint += `?userId=${userId}`;
  }
  return await fetch(endPoint, {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
      Authorization: cookies.get(CHILD_TOKEN),
    },
  });
};

export const teamDiscountRequest = async (responseData) => {
  return await fetch(`${mainRoute.route + path.teamdiscount}`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Authorization: '',
    },
    body: JSON.stringify({ ...responseData }),
  });
};

export const checkUniqueValues = async (uniqueFields) => {
  return await fetch(`${mainRoute.route + path.unitsearch}`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      authorization: cookies.get(PARENT_TOKEN),
    },
    body: JSON.stringify(uniqueFields),
  });
};

//
export const submitPlayerData = async (data) => {
  return await fetch(`${mainRoute.route + path.sinUpStep2}`, {
    method: 'POST',
    headers: {
      authorization: cookies.get(PARENT_TOKEN),
    },
    body: data,
  });
};

// Request function get userName and Stripe Token and send to Back
export const reactivationPlayerSendInfoToBack = async (userName) => {
  return await fetch(`${mainRoute.route + path.continueSubscription}`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      authorization: cookies.get(PARENT_TOKEN),
    },
    body: JSON.stringify({
      username: userName,
    }),
  });
};

export const joinMailingRequest = async (responseData) => {
  return await fetch(`${mainRoute.route + path.joinMailingList}`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({ ...responseData }),
  });
};

export const listOfCategoriesVimeo = async (token, route) => {
  return await fetch(`${mainRoute.route + path[route]}`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      authorization: cookies.get(token),
    },
  });
};

export const listOfVideosVimeo = async (uri, page) => {
  return await fetch(`${mainRoute.route + path.videoForChild}`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      authorization: cookies.get(CHILD_TOKEN),
    },
    body: JSON.stringify({ uri: `${uri}/videos`, page: page }),
  });
};

export const searchListOfVideosVimeo = async (
  requestedPage,
  countElementsPerPage = 25,
  searchRequestString,
) => {
  return await fetch(`${mainRoute.route}${path.search}`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      authorization: cookies.get(CHILD_TOKEN),
    },
    body: JSON.stringify({
      page: requestedPage,
      perPage: countElementsPerPage,
      substring: searchRequestString,
    }),
  });
};

export const changeWatchedToggle = async (videoLink, videoDuration) => {
  const link = videoLink.slice(18);
  const finalLink = `/videos/${link}`;
  return await fetch(`${mainRoute.route + path.viewed}`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      authorization: cookies.get(CHILD_TOKEN),
    },
    body: JSON.stringify({ uri: finalLink, timeVideo: videoDuration }),
  });
};

export const loginAsPlayer = async (userName) => {
  // ==========================change 'route'==================================
  return await fetch(`${mainRoute.route + path.loginAsPlayer}`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      authorization: cookies.get(PARENT_TOKEN),
    },
    body: JSON.stringify({ username: userName }),
  });
};

export const resetAllWatchedVideoInCategory = async (uri) => {
  // ========     ==========      ============      =============     ========
  return await fetch(`${mainRoute.route + path.deleteViewedToggle}`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      authorization: cookies.get(CHILD_TOKEN),
    },
    body: JSON.stringify({ resetCategory: [`${uri}/videos`] }),
  });
};

export const resetAllWatchedVideoInSession = async (URIs) => {
  return await fetch(`${mainRoute.route + path.deleteViewedSession}`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      authorization: cookies.get(CHILD_TOKEN),
    },
    body: JSON.stringify({ URIs }),
  });
};

export const sevenDaysMoneyBack = async (typeOfCancel, reason) => {
  return await fetch(`${mainRoute.route + path.moneyBack}`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      authorization: cookies.get(PARENT_TOKEN),
    },
    body: JSON.stringify({
      why: reason,
      typeOfCancel: typeOfCancel,
    }),
  });
};

export async function stripeTokenHandler({ id, signUpData }) {
  return await fetch(`${mainRoute.route + path.signUpStep3Token}`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({ id, ...signUpData }),
  });
}

export async function stripeSubscriptionForChildren({ id, data }) {
  return await fetch(`${mainRoute.route + path.addChildrenSubscription}`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({ id, ...data }),
  });
}

export async function checkUnicValuesInBase(emailAndUsername) {
  return await fetch(`${mainRoute.route + path.unitsearch}`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({ emailAndUsername }),
  });
}

export async function billingRequest() {
  return await fetch(`${mainRoute.route + path.retrievebilling}`, {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
      Authorization: cookies.get(PARENT_TOKEN),
    },
  });
}

export async function changeBillingRequest(values, id, stripeCus) {
  return await fetch(`${mainRoute.route + path.changebilling}`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Authorization: cookies.get(PARENT_TOKEN),
    },
    body: JSON.stringify({ values, id, stripeCus }),
  });
}
export const cancelSubscriptionForChild = async (usernameAndReasonObj) => {
  return await fetch(`${mainRoute.route + path.cancelsubscription}`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      authorization: cookies.get(PARENT_TOKEN),
    },
    body: JSON.stringify(usernameAndReasonObj),
  });
};

export const forgotPassRequest = async (values) => {
  return await fetch(`${mainRoute.route + path.restorePassEmail}`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({ email: values }),
  });
};

export const sendNewPass = async (values, token) => {
  return await fetch(`${mainRoute.route + path.newPassRequest}`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({ password: values, recoveryToken: token }),
  });
};

export const changeEmail = async (email) => {
  return await fetch(`${mainRoute.route + path.changeemail}`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      authorization: cookies.get(PARENT_TOKEN),
    },
    body: JSON.stringify({ email }),
  });
};

export const recoveryEmail = async (tokenFromUrl) => {
  return await fetch(`${mainRoute.route + path.changeemailback}`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      // 'authorization': cookies.get(PARENT_TOKEN)
    },
    body: JSON.stringify({ tokenFromUrl }),
  });
};

export const addMailChimp = async (responseData) => {
  return await fetch(`${mainRoute.route + path.addmail}`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Authorization: '',
    },
    body: JSON.stringify({ ...responseData }),
  });
};

/** This request creates new training plan or replaced current training plan
 * based on input user data / CreateTrainingGoalForm */
export const createNewTrainingPlan = async (data) => {
  return await fetch(`${mainRoute.route}${path.goal}`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      authorization: cookies.get(CHILD_TOKEN),
    },
    body: JSON.stringify(data),
  });
};

/** This request uses for getting created training plan
 * Data uses in training plan component */
// запрос для получения нового тренировочного плана
export const getTrainingPlan = async (userId = undefined) => {
  let endPoint = `${mainRoute.route}${path.goal}`;
  if (userId) {
    endPoint += `?userId=${userId}`;
  }
  const res = await fetch(endPoint, {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
      authorization: cookies.get(CHILD_TOKEN),
    },
  });
  return res;
};

/** This request uses for getting closed goals list,
 * based on got data we form content of reward center component */
export const getChildAwardList = async (numberOfPage = 1, userId = undefined) => {
  let endPoint = `${mainRoute.route}${path.certificationCenter}?page=${numberOfPage}`;
  if (userId) {
    endPoint += `&userId=${userId}`;
  }
  return await fetch(endPoint, {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
      authorization: cookies.get(CHILD_TOKEN),
    },
  });
};

// goal/certificate/11 (скачивание сертификата, path параметром передается id сертификата)
export const downloadRewardCertificate = async (certificateId) => {
  return await fetch(`${mainRoute.route}${path.downloadCertificate}/${certificateId}`, {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
      authorization: cookies.get(CHILD_TOKEN),
    },
  });
};

// weak streak запрос
export const getWeeklyStreak = async () => {
  return await fetch(`${mainRoute.route}${path.weeklyStreak}`, {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
      authorization: cookies.get(CHILD_TOKEN),
    },
  });
};

export const adjustWatchedVideoCount = async (data) => {
  return await fetch(`${mainRoute.route}${path.watchedVideoCountAdjustment}`, {
    method: 'PUT',
    headers: {
      'Content-Type': 'application/json',
      authorization: cookies.get(CHILD_TOKEN),
    },
    body: JSON.stringify(data),
  });
};

export const activateTrialPeriod = async () => {
  return await fetch(`${mainRoute.route}${path.activateFreeTrial}`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      authorization: cookies.get(PARENT_TOKEN),
    },
  });
};

export const getFreeTrialDaysLeft = async () => {
  return await fetch(`${mainRoute.route}${path.getFreeTrialDaysLeft}`, {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
      authorization: cookies.get(PARENT_TOKEN),
    },
  });
};

export const getAllTimeViewedVideo = async (userId = undefined) => {
  let endPoint = `${mainRoute.route}${path.allTimeViewedVideo}`;
  if (userId) {
    endPoint += `?userId=${userId}`;
  }
  return await fetch(endPoint, {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
      authorization: cookies.get(CHILD_TOKEN),
    },
  });
};

export const getReportsData = async (year = new Date().getFullYear(), userId = undefined) => {
  let endPoint = `${mainRoute.route}${path.reports}${year}`;
  if (userId) {
    endPoint += `&userId=${userId}`;
  }
  return await fetch(endPoint, {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
      authorization: cookies.get(CHILD_TOKEN),
    },
  });
};

/**
 *  POST request with the following body:
 *  {
 *    "actionTypeCategory": string
 *  }
 * 
 *  returns:
*     {
        "data": {
          "id": 2,
          "childId": 3,
          "updatedAt": "2023-05-19T18:56:10.398Z",
          "createdAt": "2023-05-19T18:56:10.398Z"
        }
      }
 */
export const createVideoCategoryBookmark = async (data) => {
  const result = await fetch(`${mainRoute.route}${path.videoCategoryBookmark}`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      authorization: cookies.get(CHILD_TOKEN),
    },
    body: JSON.stringify(data),
  });
  return result.json();
};

/**
 *  DELETE request with the following body:
 *  {
 *    "bookmarkId": number
 *  }
 * 
 *  returns:
*     {
        "msg": "Video categroy bookmark with ID ${id} has been successfully deleted!"
      }
 */
export const deleteVideoCategoryBookmarkBySubTitle = async (data) => {
  const result = await fetch(`${mainRoute.route}${path.videoCategoryBookmark}`, {
    method: 'DELETE',
    headers: {
      'Content-Type': 'application/json',
      authorization: cookies.get(CHILD_TOKEN),
    },
    body: JSON.stringify(data),
  });
  return result.json();
};

/**
 * GET request 
 * 
 * childId, for which bookmarks are selected, is extracted on the back end from JWT
 * 
 * returns:
  *   {
        "data": [
          {
            "id": number,
            "childId": number,
            "actionTypeCategory": string,
            "createdAt": Date,
            "updatedAt": Date
          },
        ]
      }
 */
export const getAllVideoCategoryBookmarks = async () => {
  const result = await fetch(`${mainRoute.route}${path.videoCategoryBookmark}`, {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
      authorization: cookies.get(CHILD_TOKEN),
    },
  });
  return result.json();
};

export const createFavoriteJourney = async (data) => {
  const result = await fetch(`${mainRoute.route}${path.addFavoriteJourney}`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      authorization: cookies.get(CHILD_TOKEN),
    },
    body: JSON.stringify(data),
  });
  return result.json();
};

export const getFavoriteJourneys = async () => {
  const result = await fetch(`${mainRoute.route}${path.getFavoriteJournerys}`, {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
      authorization: cookies.get(CHILD_TOKEN),
    },
  });
  return result.json();
};

export const deleteFavoriteBySubTitle = async (data) => {
  const result = await fetch(`${mainRoute.route}${path.deleteFavoriteJourney}`, {
    method: 'DELETE',
    headers: {
      'Content-Type': 'application/json',
      authorization: cookies.get(CHILD_TOKEN),
    },
    body: JSON.stringify(data),
  });
  return result.json();
};

export const createHomework = async (data) => {
  const result = await fetch(`${mainRoute.route}${path.addHomework}`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      authorization: cookies.get(CHILD_TOKEN),
    },
    body: JSON.stringify(data),
  });
  return result.json();
};

export const getHomework = async (params) => {
  const queryParams = new URLSearchParams(params).toString();
  const result = await fetch(`${mainRoute.route}${path.homework}?${queryParams}`, {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
      authorization: cookies.get(CHILD_TOKEN),
    },
  });
  return result.json();
};

export const deleteHomework = async (data) => {
  const result = await fetch(`${mainRoute.route}${path.deleteHomework}`, {
    method: 'DELETE',
    headers: {
      'Content-Type': 'application/json',
      authorization: cookies.get(CHILD_TOKEN),
    },
    body: JSON.stringify(data),
  });
  return result.json();
};

export const updateStatusHomework = async (data) => {
  const result = await fetch(`${mainRoute.route}${path.homework}/update-status`, {
    method: 'PUT',
    headers: {
      'Content-Type': 'application/json',
      authorization: cookies.get(CHILD_TOKEN),
    },
    body: JSON.stringify(data),
  });
  return result.json();
};

export const notifyHomework = async (id) => {
  const result = await fetch(`${mainRoute.route}${path.homeworkNotify}/${id}`, {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
      authorization: cookies.get(CHILD_TOKEN),
    },
  });
  return result.json();
};

export const getContest = async (id) => {
  const result = await fetch(`${mainRoute.route}${path.contest}/${id}`, {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
      authorization: cookies.get(CHILD_TOKEN),
    },
  });
  return result.json();
};

export const createContest = async (data) => {
  const result = await fetch(`${mainRoute.route}${path.contest}`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      authorization: cookies.get(CHILD_TOKEN),
    },
    body: JSON.stringify(data),
  });
  return result.json();
};

export const notifyContest = async (id) => {
  const result = await fetch(`${mainRoute.route}${path.contest}/${id}`, {
    method: 'PATCH',
    headers: {
      'Content-Type': 'application/json',
      authorization: cookies.get(CHILD_TOKEN),
    },
  });
  return result.json();
};

export const getContestByReference = async (id) => {
  const result = await fetch(`${mainRoute.route}${path.contest}/ref/${id}`, {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
      authorization: cookies.get(CHILD_TOKEN),
    },
  });
  return result.json();
};

export const getHomeworkById = async (id) => {
  const result = await fetch(`${mainRoute.route}${path.homework}/${id}`, {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
      authorization: cookies.get(CHILD_TOKEN),
    },
  });
  return result.json();
};

export const addHomeworkTag = async (id, data) => {
  const result = await fetch(`${mainRoute.route}${path.homework}/tagging/${id}`, {
    method: 'PUT',
    headers: {
      'Content-Type': 'application/json',
      authorization: cookies.get(CHILD_TOKEN),
    },
    body: JSON.stringify(data),
  });
  return result.json();
};

export const createHiddenFolder = async (data) => {
  const result = await fetch(`${mainRoute.route}${path.addHidden}`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      authorization: cookies.get(CHILD_TOKEN),
    },
    body: JSON.stringify(data),
  });
  return result.json();
};

export const getHiddenFolders = async () => {
  const result = await fetch(`${mainRoute.route}${path.hidden}`, {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
      authorization: cookies.get(CHILD_TOKEN),
    },
  });
  return result.json();
};

export const deleteHiddenBySubTitle = async (data) => {
  const result = await fetch(`${mainRoute.route}${path.deleteHidden}`, {
    method: 'DELETE',
    headers: {
      'Content-Type': 'application/json',
      authorization: cookies.get(CHILD_TOKEN),
    },
    body: JSON.stringify(data),
  });
  return result.json();
};

export const createHomeworkReport = async (data) => {
  const result = await fetch(`${mainRoute.route}${path.addHomeworkReport}`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      authorization: cookies.get(CHILD_TOKEN),
    },
    body: JSON.stringify(data),
  });
  return result.json();
};

export const getHomeworkReportsByTeamId = async (id) => {
  const result = await fetch(`${mainRoute.route}${path.getHomeworkReports}/${id}`, {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
      authorization: cookies.get(CHILD_TOKEN),
    },
  });
  return result.json();
};

export const getHomeworkReportsByUserId = async () => {
  const result = await fetch(`${mainRoute.route}${path.getHomeworkReports}`, {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
      authorization: cookies.get(CHILD_TOKEN),
    },
  });
  return result.json();
};

export const deleteHomeworkReport = async (id) => {
  const result = await fetch(`${mainRoute.route}${path.getHomeworkReports}/${id}`, {
    method: 'DELETE',
    headers: {
      'Content-Type': 'application/json',
      authorization: cookies.get(CHILD_TOKEN),
    },
  });
  return result.json();
};

export const deleteHomeworkReportByUser = async (param) => {
  const result = await fetch(
    `${mainRoute.route}${path.getHomeworkReports}/team/${param.teamId}/${param.userId}`,
    {
      method: 'DELETE',
      headers: {
        'Content-Type': 'application/json',
        authorization: cookies.get(CHILD_TOKEN),
      },
    },
  );
  return result.json();
};

export const deleteHomeworkReportByTeamId = async (id) => {
  const result = await fetch(`${mainRoute.route}${path.getHomeworkReports}/team-report/${id}`, {
    method: 'DELETE',
    headers: {
      'Content-Type': 'application/json',
      authorization: cookies.get(CHILD_TOKEN),
    },
  });
  return result.json();
};

export const updateHomeworkAssignedUsersHomework = async (id, data) => {
  const result = await fetch(`${mainRoute.route}${path.homework}/${id}/assigned-users`, {
    method: 'PUT',
    headers: {
      'Content-Type': 'application/json',
      authorization: cookies.get(CHILD_TOKEN),
    },
    body: JSON.stringify(data),
  });
  return result.json();
};

export const hideHomeworkForUser = async (id, data) => {
  const result = await fetch(`${mainRoute.route}${path.homework}/${id}/hide-for-user`, {
    method: 'PUT',
    headers: {
      'Content-Type': 'application/json',
      authorization: cookies.get(CHILD_TOKEN),
    },
    body: JSON.stringify(data),
  });
  return result.json();
};

export const unhideHomeworkForUser = async (id, data) => {
  const result = await fetch(`${mainRoute.route}${path.homework}/${id}/unhide-for-user`, {
    method: 'PUT',
    headers: {
      'Content-Type': 'application/json',
      authorization: cookies.get(CHILD_TOKEN),
    },
    body: JSON.stringify(data),
  });
  return result.json();
};

export const addNextUpIndividualHomework = async (id, userId) => {
  const result = await fetch(
    `${mainRoute.route}${path.homework}/${id}/add-next-up-individual/${userId}`,
    {
      method: 'PUT',
      headers: {
        'Content-Type': 'application/json',
        authorization: cookies.get(CHILD_TOKEN),
      },
    },
  );
  return result.json();
};

export const removeNextUpIndividualHomework = async (id, userId) => {
  const result = await fetch(
    `${mainRoute.route}${path.homework}/${id}/remove-next-up-individual/${userId}`,
    {
      method: 'PUT',
      headers: {
        'Content-Type': 'application/json',
        authorization: cookies.get(CHILD_TOKEN),
      },
    },
  );
  return result.json();
};

export const createChallenge = async (data) => {
  const result = await fetch(`${mainRoute.route}${path.challenge}`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      authorization: cookies.get(CHILD_TOKEN),
    },
    body: JSON.stringify(data),
  });
  return result.json();
};

export const getChallenge = async (id) => {
  const result = await fetch(`${mainRoute.route}${path.challenge}/${id}`, {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
      authorization: cookies.get(CHILD_TOKEN),
    },
  });
  return result.json();
};

export const duplicateChallenge = async (id, data) => {
  const result = await fetch(`${mainRoute.route}${path.challenge}/duplicate/${id}`, {
    method: 'PUT',
    headers: {
      'Content-Type': 'application/json',
      authorization: cookies.get(CHILD_TOKEN),
    },
    body: JSON.stringify(data),
  });
  return result.json();
};

export const stopChallenge = async (id, data) => {
  const result = await fetch(`${mainRoute.route}${path.challenge}/stop/${id}`, {
    method: 'PUT',
    headers: {
      'Content-Type': 'application/json',
      authorization: cookies.get(CHILD_TOKEN),
    },
    body: JSON.stringify(data),
  });
  return result.json();
};

export const repeatChallenge = async (id, data) => {
  const result = await fetch(`${mainRoute.route}${path.challenge}/repeat/${id}`, {
    method: 'PUT',
    headers: {
      'Content-Type': 'application/json',
      authorization: cookies.get(CHILD_TOKEN),
    },
    body: JSON.stringify(data),
  });
  return result.json();
};

export const notifyChallenge = async (id) => {
  const result = await fetch(`${mainRoute.route}${path.challenge}/${id}`, {
    method: 'PATCH',
    headers: {
      'Content-Type': 'application/json',
      authorization: cookies.get(CHILD_TOKEN),
    },
  });
  return result.json();
};

export const getChallengeScore = async (id) => {
  const result = await fetch(`${mainRoute.route}${path.challenge}/score/${id}`, {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
      authorization: cookies.get(CHILD_TOKEN),
    },
  });
  return result.json();
};

export const resetChallengeScore = async (id) => {
  const result = await fetch(`${mainRoute.route}${path.challenge}/score/${id}`, {
    method: 'PUT',
    headers: {
      'Content-Type': 'application/json',
      authorization: cookies.get(CHILD_TOKEN),
    },
  });
  return result.json();
};

export const getWeeklyPlans = async (params) => {
  const queryParams = new URLSearchParams(params).toString();
  const result = await fetch(`${mainRoute.route}${path.weeklyPlans}?${queryParams}`, {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
      authorization: cookies.get(CHILD_TOKEN),
    },
  });
  return result.json();
};

export const deleteWeeklyPlan = async (id) => {
  const result = await fetch(`${mainRoute.route}${path.weeklyPlans}/${id}`, {
    method: 'DELETE',
    headers: {
      'Content-Type': 'application/json',
      authorization: cookies.get(CHILD_TOKEN),
    },
  });
  return result.json();
};

export const createWeeklyPlan = async (id) => {
  const result = await fetch(`${mainRoute.route}${path.weeklyPlans}/${id}`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      authorization: cookies.get(CHILD_TOKEN),
    },
  });
  return result.json();
};

export const getWeeklyPlansByChildId = async (childId) => {
  const result = await fetch(`${mainRoute.route}${path.weeklyPlans}/child/${childId}`, {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
      authorization: cookies.get(CHILD_TOKEN),
    },
  });
  return result.json();
};

export const deleteWeeklyPlanByFolderId = async (childId, folderId) => {
  const result = await fetch(`${mainRoute.route}${path.weeklyPlans}/child/${childId}/${folderId}`, {
    method: 'DELETE',
    headers: {
      'Content-Type': 'application/json',
      authorization: cookies.get(CHILD_TOKEN),
    },
  });
  return result.json();
};

export const createWeeklyPlanByFolderId = async (childId, folderId) => {
  const result = await fetch(`${mainRoute.route}${path.weeklyPlans}/child/${childId}/${folderId}`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      authorization: cookies.get(CHILD_TOKEN),
    },
  });
  return result.json();
};

export const hideWeeklyPlanForChild = async (childId, folderId) => {
  const result = await fetch(
    `${mainRoute.route}${path.weeklyPlans}/child/${childId}/hide/${folderId}`,
    {
      method: 'PUT',
      headers: {
        'Content-Type': 'application/json',
        authorization: cookies.get(CHILD_TOKEN),
      },
    },
  );
  return result.json();
};

export const unhideWeeklyPlanForChild = async (childId, folderId) => {
  const result = await fetch(
    `${mainRoute.route}${path.weeklyPlans}/child/${childId}/unhide/${folderId}`,
    {
      method: 'PUT',
      headers: {
        'Content-Type': 'application/json',
        authorization: cookies.get(CHILD_TOKEN),
      },
    },
  );
  return result.json();
};

export const hideWeeklyPlan = async (folderId, childId) => {
  const result = await fetch(`${mainRoute.route}${path.weeklyPlans}/hide/${folderId}/${childId}`, {
    method: 'PUT',
    headers: {
      'Content-Type': 'application/json',
      authorization: cookies.get(CHILD_TOKEN),
    },
  });
  return result.json();
};

export const unhideWeeklyPlan = async (folderId, childId) => {
  const result = await fetch(
    `${mainRoute.route}${path.weeklyPlans}/unhide/${folderId}/${childId}`,
    {
      method: 'PUT',
      headers: {
        'Content-Type': 'application/json',
        authorization: cookies.get(CHILD_TOKEN),
      },
    },
  );
  return result.json();
};

export const createKeySkillByFolderId = async (id) => {
  const result = await fetch(`${mainRoute.route}${path.keySkillMoves}/${id}`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      authorization: cookies.get(CHILD_TOKEN),
    },
  });
  return result.json();
};

export const createKeySkillForChild = async (childId, folderId) => {
  const result = await fetch(
    `${mainRoute.route}${path.keySkillMoves}/child/${childId}/${folderId}`,
    {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        authorization: cookies.get(CHILD_TOKEN),
      },
    },
  );
  return result.json();
};

export const getKeySkillsByChildId = async (childId) => {
  const result = await fetch(`${mainRoute.route}${path.keySkillMoves}/child/${childId}`, {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
      authorization: cookies.get(CHILD_TOKEN),
    },
  });
  return result.json();
};

export const getKeySkillById = async (childId, id) => {
  const result = await fetch(`${mainRoute.route}${path.keySkillMoves}/child/${childId}/${id}`, {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
      authorization: cookies.get(CHILD_TOKEN),
    },
  });
  return result.json();
};

export const hideKeySkillForChild = async (childId, folderId) => {
  const result = await fetch(
    `${mainRoute.route}${path.keySkillMoves}/child/${childId}/hide/${folderId}`,
    {
      method: 'PUT',
      headers: {
        'Content-Type': 'application/json',
        authorization: cookies.get(CHILD_TOKEN),
      },
    },
  );
  return result.json();
};

export const unhideKeySkillForChild = async (childId, folderId) => {
  const result = await fetch(
    `${mainRoute.route}${path.keySkillMoves}/child/${childId}/unhide/${folderId}`,
    {
      method: 'PUT',
      headers: {
        'Content-Type': 'application/json',
        authorization: cookies.get(CHILD_TOKEN),
      },
    },
  );
  return result.json();
};

export const hideKeySkill = async (folderId, childId) => {
  const result = await fetch(
    `${mainRoute.route}${path.keySkillMoves}/hide/${folderId}/${childId}`,
    {
      method: 'PUT',
      headers: {
        'Content-Type': 'application/json',
        authorization: cookies.get(CHILD_TOKEN),
      },
    },
  );
  return result.json();
};

export const unhideKeySkill = async (folderId, childId) => {
  const result = await fetch(
    `${mainRoute.route}${path.keySkillMoves}/unhide/${folderId}/${childId}`,
    {
      method: 'PUT',
      headers: {
        'Content-Type': 'application/json',
        authorization: cookies.get(CHILD_TOKEN),
      },
    },
  );
  return result.json();
};

export const getKeySkills = async (params) => {
  const queryParams = new URLSearchParams(params).toString();
  const result = await fetch(`${mainRoute.route}${path.keySkillMoves}?${queryParams}`, {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
      authorization: cookies.get(CHILD_TOKEN),
    },
  });
  return result.json();
};

export const deleteKeySkill = async (folderId) => {
  const result = await fetch(`${mainRoute.route}${path.keySkillMoves}/${folderId}`, {
    method: 'DELETE',
    headers: {
      'Content-Type': 'application/json',
      authorization: cookies.get(CHILD_TOKEN),
    },
  });
  return result.json();
};

export const deleteKeySkillForChild = async (childId, folderId) => {
  const result = await fetch(
    `${mainRoute.route}${path.keySkillMoves}/child/${childId}/${folderId}`,
    {
      method: 'DELETE',
      headers: {
        'Content-Type': 'application/json',
        authorization: cookies.get(CHILD_TOKEN),
      },
    },
  );
  return result.json();
};

export const createCustomTrainingByFolderId = async (id) => {
  const result = await fetch(`${mainRoute.route}${path.customTraining}/${id}`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      authorization: cookies.get(CHILD_TOKEN),
    },
  });
  return result.json();
};

export const createCustomTrainingForChild = async (childId, folderId) => {
  const result = await fetch(
    `${mainRoute.route}${path.customTraining}/child/${childId}/${folderId}`,
    {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        authorization: cookies.get(CHILD_TOKEN),
      },
    },
  );
  return result.json();
};

export const getCustomTrainingsByChildId = async (childId) => {
  const result = await fetch(`${mainRoute.route}${path.customTraining}/child/${childId}`, {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
      authorization: cookies.get(CHILD_TOKEN),
    },
  });
  return result.json();
};

export const getCustomTrainingById = async (childId, id) => {
  const result = await fetch(`${mainRoute.route}${path.customTraining}/child/${childId}/${id}`, {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
      authorization: cookies.get(CHILD_TOKEN),
    },
  });
  return result.json();
};

export const hideCustomTrainingForChild = async (childId, folderId) => {
  const result = await fetch(
    `${mainRoute.route}${path.customTraining}/child/${childId}/hide/${folderId}`,
    {
      method: 'PUT',
      headers: {
        'Content-Type': 'application/json',
        authorization: cookies.get(CHILD_TOKEN),
      },
    },
  );
  return result.json();
};

export const unhideCustomTrainingForChild = async (childId, folderId) => {
  const result = await fetch(
    `${mainRoute.route}${path.customTraining}/child/${childId}/unhide/${folderId}`,
    {
      method: 'PUT',
      headers: {
        'Content-Type': 'application/json',
        authorization: cookies.get(CHILD_TOKEN),
      },
    },
  );
  return result.json();
};

export const hideCustomTraining = async (folderId, childId) => {
  const result = await fetch(
    `${mainRoute.route}${path.customTraining}/hide/${folderId}/${childId}`,
    {
      method: 'PUT',
      headers: {
        'Content-Type': 'application/json',
        authorization: cookies.get(CHILD_TOKEN),
      },
    },
  );
  return result.json();
};

export const unhideCustomTraining = async (folderId, childId) => {
  const result = await fetch(
    `${mainRoute.route}${path.customTraining}/unhide/${folderId}/${childId}`,
    {
      method: 'PUT',
      headers: {
        'Content-Type': 'application/json',
        authorization: cookies.get(CHILD_TOKEN),
      },
    },
  );
  return result.json();
};

export const getCustomTrainings = async (params) => {
  const queryParams = new URLSearchParams(params).toString();
  const result = await fetch(`${mainRoute.route}${path.customTraining}?${queryParams}`, {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
      authorization: cookies.get(CHILD_TOKEN),
    },
  });
  return result.json();
};

export const deleteCustomTraining = async (folderId) => {
  const result = await fetch(`${mainRoute.route}${path.customTraining}/${folderId}`, {
    method: 'DELETE',
    headers: {
      'Content-Type': 'application/json',
      authorization: cookies.get(CHILD_TOKEN),
    },
  });
  return result.json();
};

export const deleteCustomTrainingForChild = async (childId, folderId) => {
  const result = await fetch(
    `${mainRoute.route}${path.customTraining}/child/${childId}/${folderId}`,
    {
      method: 'DELETE',
      headers: {
        'Content-Type': 'application/json',
        authorization: cookies.get(CHILD_TOKEN),
      },
    },
  );
  return result.json();
};

export const addFolder = async (folderData) => {
  const result = await fetch(`${mainRoute.route}${path.folder}`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      authorization: cookies.get(CHILD_TOKEN),
    },
    body: JSON.stringify(folderData),
  });
  return result.json();
};

export const getOpenFolders = async (params) => {
  const queryParams = new URLSearchParams(params).toString();
  const response = await fetch(`${mainRoute.route}${path.folder}?${queryParams}`, {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
      authorization: cookies.get(CHILD_TOKEN),
    },
  });

  return response.json();
};

export const getMyFolders = async () => {
  const response = await fetch(`${mainRoute.route}${path.folder}/my-sessions`, {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
      authorization: cookies.get(CHILD_TOKEN),
    },
  });

  return response.json();
};

export const getOpenFoldersByChildId = async (params) => {
  const queryParams = new URLSearchParams(params).toString();
  const result = await fetch(`${mainRoute.route}${path.folder}/open?${queryParams}`, {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
      authorization: cookies.get(CHILD_TOKEN),
    },
  });
  return result.json();
};

export const getMyFoldersByChildId = async (params) => {
  const queryParams = new URLSearchParams(params).toString();
  const result = await fetch(`${mainRoute.route}${path.folder}/my?${queryParams}`, {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
      authorization: cookies.get(CHILD_TOKEN),
    },
  });
  return result.json();
};

export const closeFolder = async (id) => {
  const result = await fetch(`${mainRoute.route}${path.folder}/${id}/close`, {
    method: 'PATCH',
    headers: {
      'Content-Type': 'application/json',
      authorization: cookies.get(CHILD_TOKEN),
    },
  });
  return result.json();
};

export const pinnedFolder = async (id) => {
  const result = await fetch(`${mainRoute.route}${path.folder}/${id}/pinned`, {
    method: 'PATCH',
    headers: {
      'Content-Type': 'application/json',
      authorization: cookies.get(CHILD_TOKEN),
    },
  });
  return result.json();
};

export const bookmarkFolder = async (id) => {
  const result = await fetch(`${mainRoute.route}${path.folder}/${id}/bookmark`, {
    method: 'PATCH',
    headers: {
      'Content-Type': 'application/json',
      authorization: cookies.get(CHILD_TOKEN),
    },
  });
  return result.json();
};

export const updateFolder = async (data) => {
  return await fetch(`${mainRoute.route}${path.folder}/${data.id}}`, {
    method: 'PUT',
    headers: {
      'Content-Type': 'application/json',
      authorization: cookies.get(CHILD_TOKEN),
    },
    body: JSON.stringify(data),
  });
};

export const addFile = async (fileData) => {
  const result = await fetch(`${mainRoute.route}${path.file}`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      authorization: cookies.get(CHILD_TOKEN),
    },
    body: JSON.stringify(fileData),
  });
  return result.json();
};

export const getFilesByFolder = async (folderId, params) => {
  const queryParams = new URLSearchParams(params).toString();
  const result = await fetch(`${mainRoute.route}${path.file}/${folderId}?${queryParams}`, {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
      authorization: cookies.get(CHILD_TOKEN),
    },
  });
  return result.json();
};

export const markAsViewed = async (id) => {
  const result = await fetch(`${mainRoute.route}${path.file}/${id}/viewed`, {
    method: 'PATCH',
    headers: {
      'Content-Type': 'application/json',
      authorization: cookies.get(CHILD_TOKEN),
    },
  });
  return result.json();
};

export const deleteFile = async (id) => {
  const result = await fetch(`${mainRoute.route}${path.file}/${id}`, {
    method: 'DELETE',
    headers: {
      'Content-Type': 'application/json',
      authorization: cookies.get(CHILD_TOKEN),
    },
  });
  return result.json();
};

export const getFileById = async (id) => {
  const result = await fetch(`${mainRoute.route}${path.file}/${id}`, {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
      authorization: cookies.get(CHILD_TOKEN),
    },
  });
  return result.json();
};

export const getFilesByChild = async () => {
  const result = await fetch(`${mainRoute.route}${path.file}`, {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
      authorization: cookies.get(CHILD_TOKEN),
    },
  });
  return result.json();
};

export const pinnedFile = async (id) => {
  const result = await fetch(`${mainRoute.route}${path.file}/${id}/pinned`, {
    method: 'PATCH',
    headers: {
      'Content-Type': 'application/json',
      authorization: cookies.get(CHILD_TOKEN),
    },
  });
  return result.json();
};

export const updateFile = async (data) => {
  return await fetch(`${mainRoute.route}${path.file}/${data.id}}`, {
    method: 'PUT',
    headers: {
      'Content-Type': 'application/json',
      authorization: cookies.get(CHILD_TOKEN),
    },
    body: JSON.stringify(data),
  });
};

export const resetViewers = async (id) => {
  const result = await fetch(`${mainRoute.route}${path.file}/${id}/reset`, {
    method: 'PATCH',
    headers: {
      'Content-Type': 'application/json',
      authorization: cookies.get(CHILD_TOKEN),
    },
  });
  return result.json();
};

export const getTeamTrainingReport = async (teamId, range) => {
  const params = new URLSearchParams();

  if (range?.from && range?.to) {
    // More robust date formatting
    const formatDate = (date) => {
      const year = date.getFullYear();
      const month = String(date.getMonth() + 1).padStart(2, '0');
      const day = String(date.getDate()).padStart(2, '0');
      return `${year}-${month}-${day}`;
    };

    params.append('startDate', formatDate(range.from));
    params.append('endDate', formatDate(range.to));
  }

  const queryString = params.toString();
  const url = `${mainRoute.route}${path.team}/${teamId}/training-report${
    queryString ? `?${queryString}` : ''
  }`;

  const result = await fetch(url, {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
      authorization: cookies.get(CHILD_TOKEN),
    },
  });
  return result.json();
};
